import { Component, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { UsuarioLogado } from 'src/app/core/models/usuario-logado.model';
import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  sidebarVisible: boolean = false;
  menusUser: MenuItem[] | undefined;
  menus: MenuItem[];
  usuario: UsuarioLogado | undefined;
  imagemLogoBase64: string;
  version: string;

  constructor(
    private authenticationService: AuthenticationService) { }

  ngOnInit() {
    this.version = environment.appVersion;

    this.usuario = this.authenticationService.obterUsuarioLogado;

    this.menusUser = [
      {
        label: this.usuario?.nome,
      },
      {
        label: 'Alterar senha',
        icon: 'pi pi-user',
        routerLink: '/oticomweb/atualizar-senha'
      },
      {
        label: 'Sair',
        icon: 'pi pi-power-off',
        command: (event) => {
          this.authenticationService.logout();
        }
      }
    ];

    this.menus = [
      {
        label: 'Dashboard',
        icon: 'pi pi-home',
        routerLink: '/oticomweb/dashboard',
        command: (event) => {
          this.clickMenu(event);
        }
      },
      {
        label: 'Meus pedidos',
        icon: 'pi pi-fw pi-list',
        routerLink: '/oticomweb/pedidos',
        command: (event) => {
          this.clickMenu(event);
        }
      },
      {
        label: 'Novo pedido',
        icon: 'pi pi-fw pi-plus',
        items: [
          {
            label: 'Ordem de Serviço (OS)',
            icon: 'pi pi-shopping-cart',
            tooltip: 'Pedido com receita',
            routerLink: '/oticomweb/ordem-de-servico',
            command: (event) => {
              this.clickMenu(event);
            }
          },
          {
            label: 'Venda',
            icon: 'pi pi-cart-plus',
            tooltip: 'Pedido sem receita',
            routerLink: '/oticomweb/pedido-venda',
            command: (event) => {
              this.clickMenu(event);
            }
          }
        ]
      },
      {
        label: 'Ajuda',
        icon: 'pi pi-fw pi-question',
        items: [
          {
            label: 'Chat Suporte',
            icon: 'pi pi-fw pi-comments',
            url: `https://chat.movidesk.com/ChatWidget/Landing/EBAB88DAB1D94FC8BB6133FCCD9DD3A5`,
            command: (event) => {
              this.clickMenu(event);
            }
          },
          {
            label: 'ÓTICOM',
            icon: 'pi pi-fw pi-oticom',
            url: 'https://oticom.com.br/',
            command: (event) => {
              this.clickMenu(event);
            }
          }
        ]
      }
    ]
  }

  clickMenu($event: any) {
    this.sidebarVisible = !this.sidebarVisible;
  }
}
